import type { ActivityProtocol, BlockAbstract, ContainerBlockAbstract, WorkSpaceAbstract } from '@lighthouse/core'
import { WorkSpaceStruct } from '@lighthouse/core'
import type { FlowNode } from '@lighthouse/shared'
import type { Draft } from 'immer'
import { atom } from 'jotai'
import { atomWithImmer } from 'jotai-immer'

import type { NodeIdWithScope } from '../page/types'
import { applyDraftPayload } from '../utils/applyDraftPayload'

export const workSpaceListAtom = atomWithImmer<WorkSpaceAbstract[]>([])
export const currentWorkSpaceIdAtom = atom('')

export const activityListAtom = atomWithImmer<ActivityProtocol[]>([])

export const workSpaceAtom = atom(
    get => {
        const list = get(workSpaceListAtom)

        const id = get(currentWorkSpaceIdAtom)
        if (!id) {
            return { ...WorkSpaceStruct() }
        }
        const current = list.find(item => item.id === id)
        return current ?? { ...WorkSpaceStruct() }
    },
    (get, set, payload: WorkSpaceAbstract | ((draft: Draft<WorkSpaceAbstract>) => void)) =>
        set(workSpaceListAtom, draft => {
            const id = get(currentWorkSpaceIdAtom)
            const workSpace = draft.find(item => item.id === id)
            if (!workSpace) {
                const newWorkSpace = WorkSpaceStruct({ id })
                applyDraftPayload(newWorkSpace, payload)
                draft.push(newWorkSpace)
                return
            }

            applyDraftPayload(workSpace, payload)
        })
)

/** 框选栅格节点 */
export const copiedBoxSelectionNodesSnapshotAtom = atom<{
    copiedIds: NodeIdWithScope[]
    blocks: BlockAbstract[]
    syncComponents: ContainerBlockAbstract[]
}>({
    copiedIds: [],
    blocks: [],
    syncComponents: []
})

export const copiedFlowNodeSnapshotAtom = atom<{
    workflowId?: string
    node: FlowNode | null
    pasteCount: number
}>({
    workflowId: undefined,
    node: null,
    pasteCount: 0
})
